<template>
  <!--
          作者：kmdshop
          时间：2019-10-24
          描述：登录页面
      -->
  <div class="login-bg" :style="'background-image:url(' + bgimg_url + ');'">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="0px" class="demo-ruleForm login-container" @keyup.enter.native="SubmitFunc">
      <h3 class="title" style="margin-bottom: 20px;">商城运营管理系统</h3>
      <!--用户名-->
      <el-form-item prop="account"
        ><el-input
          type="text"
          v-model="ruleForm.account"
          auto-complete="off"
          placeholder="账号"
        ></el-input
      ></el-form-item>
      <!--密码-->
      <el-form-item prop="checkPass"
        ><el-input
          type="password"
          v-model="ruleForm.checkPass"
          auto-complete="off"
          placeholder="密码"
        ></el-input
      ></el-form-item>
      <!--登录-->
      <el-form-item><el-button type="primary" style="width:100%;" @click="SubmitFunc" :loading="logining">登录</el-button></el-form-item>

      <h5 class="title1" style="margin-bottom: 20px;font-size: 12px" v-if="icp != ''"><a href="https://beian.miit.gov.cn/" target="_blank">{{icp}}</a></h5>
    </el-form>
  </div>
</template>

<script>
import IndexApi from "@/api/index.js";
import bgimg from "@/assets/img/login_bg.jpg";
import UserApi from "@/api/user.js";
import { setCookie, setSessionStorage, delCookie } from "@/utils/base.js";
export default {
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*背景图片*/
      bgimg_url: bgimg,
      /*是否正在提交*/
      logining: false,
      pathroute: "",
      /*表单对象*/
      ruleForm: {
        /*用户名*/
        account: "",
        /*密码*/
        checkPass: "",
      },
      /*验证规则*/
      rules: {
        /*用户名*/
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        /*密码*/
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      /*基础配置*/
      baseData: {},
      icp :'',
    };
  },
  created() {
    delCookie('token');
    this.getData();
    if (process.env.NODE_ENV !== 'production') {
      this.ruleForm.account = process.env.NODE_USER
      this.ruleForm.checkPass = process.env.NODE_PASS
    }
  },
  methods: {
    /*获取基础配置*/
    getData() {
      let self = this;
      IndexApi.base({})
        .then((res) => {
          console.log(res)
          if(res.data.config.icp != ''){
            self.icp = res.data.config.icp;
          }
          if(res.data.config.kmd_support=="w7"){
            // locaotion.href="../../../web"
            // console.log(window.location);
            window.location.href = window.location.protocol + '//' + window.location.host;
          }
        })
        .catch((error) => {
          self.loading = false;
        });

    },

    /*登录方法*/
    SubmitFunc() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.logining = true;
          var Params = {
            username: this.ruleForm.account,
            password: this.ruleForm.checkPass,
          };
          /*调用登录接口*/
          UserApi.login(Params, true)
            .then((res) => {
              console.log(res);
              this.logining = false;
              if (res.code == 1) {
                /*保存个人信息*/
                setCookie("userinfo", res.data);
                if(res.data.supply){
                  setCookie("is_supply", 1);
                }else{
                  setCookie("is_supply", 0);
                }
                if(res.data.token != undefined){
                  setCookie("token", res.data.token);
                }
                /*设置一个登录状态*/
                setCookie("isLogin", true);
                this.pathroute = res.data.path;
                console.log(this.pathroute);
                /*跳转到首页*/
                if (this.pathroute != "") {
                  this.$router.push({ path: this.pathroute });
                } else {
                  this.$router.push({ path: "/" });
                }
              } else {
                this.$message({
                  message: "登录失败",
                  type: "error",
                });
              }
            })
            .catch((error) => {
              //接口调用方法统一处理
              this.logining = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.login-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-repeat: no-repeat;
  background-position: center;
  //background-size: 100%;
}

.login-container {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.4);

  .title {
    margin: 0 auto 20px auto;
    text-align: center;
    color: #66b1ff;
    font-size: 20px;
    border-bottom: 1px solid #d6d6d6;
    padding-bottom: 10px;
  }
  .title1 {
    margin: 20px auto 20px auto;
    text-align: center;
    color: #66b1ff;
    font-size: 20px;
    border-top: 1px solid #d6d6d6;
    padding-top: 10px;
  }
  .remember {
    margin: 0 0 35px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue